import { render, staticRenderFns } from "./ContentNewListModal.vue?vue&type=template&id=6032caf0&scoped=true&"
import script from "./ContentNewListModal.vue?vue&type=script&lang=js&"
export * from "./ContentNewListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6032caf0",
  null
  
)

export default component.exports